import React, { SVGProps } from 'react';
const tableRowsFilled = (props: SVGProps<SVGSVGElement>): JSX.Element => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M28 10.667H4V5.334h24zm0 2.666H4v5.333h24zm0 8H4v5.333h24z" /></svg>;
export default tableRowsFilled;